export function Footer(): React.ReactElement {
  return (
    <footer className="border-t bg-white mt-auto">
      <div className="mx-auto max-w-[1920px] px-6 py-3 flex items-center justify-between text-xs text-muted-foreground">
        <span>&copy; {new Date().getFullYear()} Seagars</span>
        <span>Insurance Valuation Platform</span>
      </div>
    </footer>
  );
}
